/**
 * What the office assumes about a Termin nobody has filled in yet.
 *
 * These are *create* defaults only. Anything that already carries its own durations — an
 * appointment being edited, a block being dragged — must keep them; seeding a move from here
 * would silently rewrite the Termin being moved.
 *
 * Every place that opens a fresh Termin reads these, so the disposition board's draft and the
 * upsert modal cannot disagree about what a new appointment looks like. Tasks are deliberately
 * not covered: they default to no travel at all.
 */
export const APPOINTMENT_DEFAULT_TRAVEL_MINUTES = 15;
export const APPOINTMENT_DEFAULT_DEPARTURE_MINUTES = 15;
export const APPOINTMENT_DEFAULT_WORK_MINUTES = 60;
